import esES from "./es-ES.js";
import ptBR from "./pt-BR.js";
import arSA from "./ar-SA.js";
export default {
  "es-ES": esES,
  "pt-BR": ptBR,
  "ar-SA": arSA
};